$(document).ready(function() {
    $('*').removeClass('de').removeClass('fr').removeClass('ja').removeClass('zh').removeClass('pl');
    if ($('.js_languagenavigation').html().trim().length > 0) {

    } else {
        $('#header-location').css({
            cursor: 'default',
            opacity: 0.3
        });
    }
});